const INSERT_HTML_BUTTON = "html-insert-button";
const INSERT_ADSENSE_BUTTON = "html-adsense-insert-button";
const HTML_VIEWER_ROOT = "html-component";
const IFRAME_COMPONENT = "iframe-component";
const PLUGIN_TOOLBAR_EDIT_HTML_BUTTON = "plugin-toolbar-edit-html-button";
const PLUGIN_TOOLBAR_CONTAINER_HEIGHT_BUTTON = "plugin-toolbar-container-height-button";
const PLUGIN_TOOLBAR_CONTAINER_WIDTH_BUTTON = "plugin-toolbar-container-width-button";
const EDIT_PANEL = "html-edit-panel";
const EDIT_PANEL_FOOTER_ACTIONS = "html-edit-panel-footer-actions";
const EDIT_PANEL_SEGMENTED_TOGGLE = "html-edit-panel-html-segmented-toggle";
const EDIT_PANEL_HTML_INPUT = "html-edit-panel-html-input";
const EDIT_PANEL_URL_INPUT = "html-edit-panel-url-input";
const HTML_SLIDER_MODAL = "html-slider-modal";
const HTML_HEIGHT_AUTOHEIGHT_TOGGLE = "html-dimensions-slider-toggle";
const HTML_DIMENSIONS_SLIDER = "html-dimensions-slider";
const HTML_DIMENSIONS_INPUT = "html-dimensions-input";
const AI_WIDGET_HTML_VIEWER = "ai-widget-html-viewer";
const PROMPT_INPUT_AREA = "ai-widget-prompt-input-area";
const FLOATING_CONTAINER_AI_WIDGET = "floating-container-ai-widget";
export {
  AI_WIDGET_HTML_VIEWER,
  EDIT_PANEL,
  EDIT_PANEL_FOOTER_ACTIONS,
  EDIT_PANEL_HTML_INPUT,
  EDIT_PANEL_SEGMENTED_TOGGLE,
  EDIT_PANEL_URL_INPUT,
  FLOATING_CONTAINER_AI_WIDGET,
  HTML_DIMENSIONS_INPUT,
  HTML_DIMENSIONS_SLIDER,
  HTML_HEIGHT_AUTOHEIGHT_TOGGLE,
  HTML_SLIDER_MODAL,
  HTML_VIEWER_ROOT,
  IFRAME_COMPONENT,
  INSERT_ADSENSE_BUTTON,
  INSERT_HTML_BUTTON,
  PLUGIN_TOOLBAR_CONTAINER_HEIGHT_BUTTON,
  PLUGIN_TOOLBAR_CONTAINER_WIDTH_BUTTON,
  PLUGIN_TOOLBAR_EDIT_HTML_BUTTON,
  PROMPT_INPUT_AREA
};
//# sourceMappingURL=data-hooks.js.map
